import React, { Component } from 'react';
import './Inseriscidati.css';
//import iitd from '../../images/public/registeration/iitd.png';
import clos from '../../images/public/registeration/clos.png';
import back from '../../images/public/registeration/back.png';
import logo from '../../images/public/login/logo.png';
//import ReactPhoneInput from 'react-phone-input-2';
//import { BrowserView, MobileView, isBrowser, isMobile, isTablet, isMobileOnly, isAndroid, isIOS, isFirefox, browserName } from 'react-device-detect';
import { BrowserView, MobileView } from 'react-device-detect';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
//import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
//import Confermail from '../Confermail/Confermail';
import tr from '../../libs/tr';
import AlertPnl from "../../assets/components/panel/AlertPnl";
import HideBtn from "../../assets/components/button/HideBtn";
//import DrpdwnDay from '../../assets/components/drpdwnmnu/DrpdwnDay';
//import DrpdwnMonth from '../../assets/components/drpdwnmnu/DrpdwnMonth';
//import DrpdwnYear from '../../assets/components/drpdwnmnu/DrpdwnYear';
import { userFetch, userRegisterFetch, sendCodeByEmail, statusMessage, userLogoutFetch, updateUser } from '../../libs/fetch';
import Cookies from 'universal-cookie';
//import { YearPicker, MonthPicker, DayPicker } from 'react-dropdown-date';
//import { emptyScheduled } from 'rxjs/internal/observable/empty';
import Cleave from 'cleave.js/react';
import Dropdown from 'react-dropdown';
//import { fastest } from 'sw-toolbox';
//import TagManager from 'react-gtm-module'; // Goole Tag Manager module
import FirebaseLogger from '../../libs/FirebaseLogger';
import TopBar from '../../assets/components/topbar/TopBar';
import ProgressBullets from '../../assets/components/progressBullets/ProgressBullets';
//import itabar1 from '../../images/public/registeration/nav1i.png';
//import engbar1 from '../../images/public/registeration/nav1e.png';
//import simplebar1 from '../../images/public/registeration/mobilenav1.png';
import miniArrow from '../../images/public/registeration/miniarrow.png';

var lookup = require('country-data').lookup;

const cookies = new Cookies();

class Inseriscidati extends Component {

		//
		constructor(props) {
				super(props);
				// state default
				this.state = {
						step: '1',
						redirect: false,
						redirectPrev: false,// for CSS overlay
						userRegResponse: null,
						user: null,
						dayList: [],
						day: '',
						month: '',
						year: '',
						name: '',
						surname: '',
						phoneCode: '+39',
						phone: '',
						password: '',
						password1: '',
						dateBirth: '',//'yyyy-mm-24
						email: '',
						warning: false,
						warningMessage: 'Oops!, something went wrong!',
						usrnameErr: false,
						surnameErr: false,
						passErr: false,
						phoneErr: false,
						dateBirthErr: false,
						emailErr: false,
						modal: false,
						alertAttention: false,
						passFlag: "password",
						passFlag1: "passWord1",
						passFlagid: true,
						canBeSubmitted: false,
						passwordIsMatched: false,
						isCountryPrefixValid: false,

						isModify: false,
						canModifyDateOfBirth: true,
						isFBLogin: false,
				};

				this.handleChangeMonth = this.handleChangeMonth.bind(this);
				this.handleChangePassword = this.handleChangePassword.bind(this);
				this.handleChangePassword1 = this.handleChangePassword1.bind(this);
				this.handleChangephone = this.handleChangephone.bind(this);
				this.handleChangePhoneCode = this.handleChangePhoneCode.bind(this);
				this.handleChangeName = this.handleChangeName.bind(this);
				this.handleChangeEmail = this.handleChangeEmail.bind(this);
				this.handleChangeSurName = this.handleChangeSurName.bind(this);
				this.canBeSubmitted = this.canBeSubmitted.bind(this);
				this.gotoConfermail = this.gotoConfermail.bind(this);
		}

		/*react Life cycle */

		componentDidMount() {
        FirebaseLogger.getInstance().regEvent("REGISTERATION", {}, "START");

        // const tagManagerArgs = {
				//     gtmId: 'GTM-MX2RG6H',
				//     dataLayer: {
				//       project: 'webappsci',
				//       pageCategory : 'signup',
				//     }
				//   }; // Goole Tag Manager Id
					
				//   TagManager.initialize(tagManagerArgs);
			
			
        window.gtag('event', 'conversion', {'send_to': 'AW-323718630/R1gXCNjknoQYEOabrpoB'});
				
				let url_string = window.location.href.replace(/\?\#/g, '#');

				let urlParamsStr = url_string.substr(url_string.indexOf('?') + 1, url_string.length);

				let objParams = urlParamsStr.split("&")
				// console.log("params: ", objParams);
				let params = [];
				for (var i in objParams) {
						params.push({ key: objParams[i].split("=")[0], value: objParams[i].split("=")[1] })
				}
				//console.log("params: ", params);

				for (var j in params) {
						if (params[j].key === 'landing') {
								this.setCookieParam(params[j]);
								break;
						}
				}

				
				this.setCountry('+39');
				this.refreshDays();

				//if user registers by fb
				let fb_user = JSON.parse(localStorage.getItem('fb_user'));
				//console.log("[Inseriscidati] @fb_user: ", fb_user);
				//TODO: 
				/**
				 * if user came from fb does not need to call this.checkIfUserInfoExsits();
				 * remember to disable not editing fields
				 * put a fake password for user
				 * regiseration is like normal registeration
				 * after success registeration take care of user picture
				 * //FIXME: thinks how to get rid of email confirmation for fb!!
					* 
				*/
				if(!!fb_user){
						const {name, surname, email, accessToken, photo, id_facebook} = fb_user;
						this.setState({
								name, surname, email, photo, id_facebook,
								isModify: true,
								canModifyDateOfBirth: true,
								password: accessToken,
								password1: accessToken,
								isFBLogin: true,

						});
						return;
				}
				this.checkIfUserInfoExsits();

				/**
				 * Welcome code on signup
				 */
				let url = new URL(document.URL);
				url = url.href.replace('#', '/');
				let code = (new URL(url)).searchParams.get('w');
				if(code) localStorage.setItem('welcomecode', code);

        window.fbq('trackCustom', 'StartInserting');
		}


		checkIfUserInfoExsits() {

				let access_token = cookies.get('access_token');

				if (!access_token) return;

				//getting user info
				let params = { access_token: access_token };
				//TODO: let countryCode = JSON.parse(localStorage.getItem('countryCode'));

				userFetch(this, params)
						.then((response) => {
								//console.log("[Inseriscidati] userFetch @response: ", response);
								if (response.id_ut) {
										// reload info here
										this.setState({
												isModify: true,// to disable email and password edit
												canModifyDateOfBirth: !response.data_nasc,
												name: response.name,
												surname: response.surname,
												email: response.email,
												day: !!response.data_nasc ? response.data_nasc.split('-')[2]: '',
												month: !!response.data_nasc ? response.data_nasc.split('-')[1]: '',
												year: !!response.data_nasc ? response.data_nasc.split('-')[0]: '',
												password: "**************",
												password1: "**************",
										})

								} else {
										return
								}
						});
				return
		}





/*
If user comes with facebook the sequence is this:
*/

		fbRegisteration = () => {

				let params = {
						name: this.state.name,
						surname: this.state.surname,
						password: this.state.password,
						date_of_birth: this.state.year.toString() + '-' + this.state.month.toString() + '-' + this.state.day.toString(),
						tel_cell: removeEmojis(this.state.phoneCode + this.state.phone).replace('+', ''),
						email: this.state.email,
						portal: 'sci',
						language: tr.userlng().toLowerCase(),
						source: 'web',
						id_facebook: this.state.id_facebook,
						photo: this.state.photo,
				}

				//console.log('fbRegisteration', params);
				
					/* Rest call registration*/
					try {
						userRegisterFetch(this, params)
								.then((userRegResponse) => {
										//console.log("userRegisterFetch: userRegResponse: ", userRegResponse)
										try {
												// fill storage w/ user data.
												//console.log("userLoginFetch: !!Success!!:userRegResponse.access_token  ", userRegResponse.access_token);
												cookies.set("access_token", userRegResponse.access_token);
												userFetch(this, { access_token: userRegResponse.access_token }
												).then((response) => {
													//console.log("userLoginFetch: !!Success!!:", response);
													if (!response) {
														localStorage.clear();
														cookies.remove('access_token');
														return this.props.history.push('/');
													}
													localStorage.setItem('user', JSON.stringify(response));
													return this.props.history.push('/');
												});
											} catch (e) {
												//console.log(e);
											}  
								});
				}
				catch (e) {
						//console.log(e);
				}
		}


//if any of user info is missing, he needs to update it
		updateUserInfo = () => {
				//if fb registeration..
				if (this.state.isFBLogin) return this.fbRegisteration();

				//updating missing information of profile....
				let params = {
						name: this.state.name,
						surname: this.state.surname,
						// password: this.state.password,
						date_of_birth: this.state.year.toString() + '-' + this.state.month.toString() + '-' + this.state.day.toString(),
						tel_cell: removeEmojis(this.state.phoneCode + this.state.phone).replace('+', ''),
						email: this.state.email,
						// portal: 'sci',
						// language: tr.userlng().toLowerCase(),
						// source: 'web',
				}

				//console.log("updateUserInfo params: ", params);
				try {
						let access_token = cookies.get('access_token');
						updateUser(this, access_token, params)
								.then((response) => {
										//console.log("updateUser: response: ", response)
										// null
										if (response === null) {
												//console.log('null response');
												return;
										}
										//fail
										if (response.status === "fail") {
												//console.log("updateUser: !!FAIL!!: ", response.message)
												this.handleAlert(response.message);
												
										}
										// success
										if (response.status === "success") {
														//console.log("updateUser: success!! ")
														try {
																// fill storage w/ user data.
																//console.log("userLoginFetch: !!Success!!:response.access_token  ", response.access_token);
																userFetch(this, { access_token: access_token }
																).then((response) => {
																	//console.log("userLoginFetch: !!Success!!:", response);
																	if (!response) {
																		localStorage.clear();
																		cookies.remove('access_token');
																		return this.props.history.push('/');
																	}
																	localStorage.setItem('user', JSON.stringify(response));
																	return this.props.history.push('/');
																});
															} catch (e) {
																//console.log(e);
															}                            
										}
								});
				}
				catch (e) {
						//console.log(e);
				}
				return;
		}





		setCookieParam(param) {
				if (param.value) {
						//console.log("param has this value: >>", param.value, '<< Cookie can be set!');
						cookies.set(param.key, param.value);
				} else {
						//console.log("Empty param! Do nothing ");

				}
		}

		setCountry = (countryPrefix) => {
				var selectedCountry = lookup.countries({ countryCallingCodes: countryPrefix })[0];
				//console.log(selectedCountry);
				if (!!selectedCountry) {
						this.setState({ isCountryPrefixValid: true }, () => {
								this.regInfoValidator();
						});
						//console.log("valid");
						this.setState({ phoneCode: (selectedCountry.emoji + countryPrefix) });
				}
				else {
						//console.log("not valid");
						this.setState({ isCountryPrefixValid: false }, () => {
								this.regInfoValidator();
						});
						this.setState({ phoneCode: countryPrefix });
				}
		}
		// gotoConfermail = (e) => {
		//     e.preventDefault();
		//     alert("pressed!")
		// }

		// go to ConfirmMail
		// if form is properly filled submit registration
		// @return ?

		gotoConfermail = (e) => {
				e.preventDefault();

				//if user info is updating 

				if(this.state.isModify)return this.updateUserInfo();

				//if it is a new registeration

				let params = {
						name: this.state.name,
						surname: this.state.surname,
						password: this.state.password,
						date_of_birth: this.state.year.toString() + '-' + this.state.month.toString() + '-' + this.state.day.toString(),
						tel_cell: removeEmojis(this.state.phoneCode + this.state.phone).replace('+', ''),
						email: this.state.email,
						portal: 'sci',
						language: tr.userlng().toLowerCase(),
						source: 'web',
				}

				//console.log("gotoConfermail params: ", params);

				// if (this.canBeSubmitted() && this.validateInput()) {

				/* Rest call registration*/
				try {
						userRegisterFetch(this, params)
								.then((response) => {
										//console.log("userRegisterFetch: response: ", response)

										// null
										if (response === null) {
												//console.log('null response');
												return;
										}

										//fail
										if (response.status === "fail") {
												//console.log("userRegisterFetch: !!FAIL!!: ", response.message)
												// alert(response.message);
												// do we show an alert?
												this.handleAlert(response.message);

												// TODO
												// set error state to fields that generate errors
										}

										else if (response.status === "user_not_confirmed") {
												//console.log('user_not_confirmed');
												// guess TO DO
										}

										// success
										if (response.status === "success") {

												// fill userRegResponse
												let userRegResponse = {
														access_token: response.access_token,
														user_id: response.user_id,
														name: response.name,
														surname: response.surname,
														email: this.state.email,
														phone: response.phone,
														logged: true,
														redirectprev: true
												};

												this.setState({ userRegResponse: userRegResponse });
												cookies.set("access_token", userRegResponse.access_token);

												try {
														sendCodeByEmail(this, { email: this.state.email, one_step: 1, language: tr.userlng() })
																.then((response) => {

																		// null
																		if (response === null) {
																				return;
																		}

																		// fail
																		if (response.status === "fail") {
																				//console.log("sendCodeByEmail: !!FAIL!!: ", response.message)
																				this.setState({ redirect: false, redirectprev: true });
																				// alert(response.message);
																				this.handleAlert(response.message);
																		}

																		// success
																		if (response.status === "success") {
																				let user = {
																						logged: true,
																						access_token: this.state.userRegResponse.access_token,
																						user_id: this.state.userRegResponse.user_id,
																						name: this.state.name,
																						surname: this.state.surname,
																						email: this.state.email,
																						phone: this.state.phone
																				};
																				this.setState({ userRegResponse: user });
																				this.setState({ redirect: true, redirectPrev: false });

																				// cookies.set("UserProfile", user);

																				localStorage.setItem('user', JSON.stringify(user));
																				localStorage.setItem('countryCode', JSON.stringify(this.state.phoneCode));
                                        
																				this.props.history.push({
																						pathname: '/confirm'
																				});
																		}
																		else {
																				this.setState({ redirect: false, redirectprev: true });                                    // cookies.set("UserProfile", user);
																		}
																});
												} catch (e) {
														//console.log(e);
												}
										}
								});
				}
				catch (e) {
						//console.log(e);
				}

				/* Rest call end */
				return;
		}
		/*  */

		// edit month format in MM format 
		preformatMonth = () => {
				if (this.state.month < 9) {
						return '0' + this.state.month;
				} else {
						return this.state.month;
				}
		}

		// concat national prefix to phone number
		concateDataOfBirth = () => {
				return this.state.year + '-' + this.preformatMonth() + '-' + this.state.day;
		}

		// calculate user age from dateBirth data
		// @return the age
		calculate_age = () => {
				const today_date = new Date();
				const today_year = today_date.getFullYear();
				const today_month = today_date.getMonth();
				const today_day = today_date.getDate();
				let age = today_year - this.state.year;
				if (today_month < (this.state.month - 1)) {
						age--;
				}
				if (((this.state.month - 1) === today_month) && (today_day < this.state.day)) {
						age--;
				}
				return age;
		}

		// check if user is older than 16
		// @return bool isUnder16
		checkUserUnderAge = () => {
				if (this.calculate_age() < 17) {
						statusMessage(Inseriscidati, 'User under 16')
						this.setState({
								warningMessage: tr.t("NovalidEmailPass"),
								usrnameErr: false,
								surnameErr: false,
								passErr: false,
								phoneErr: false,
								dateBirthErr: false,
								emailErr: false,
								warning: false,
						})
						return false
				}
				return true
		}

		// check if form could be submitted
		// @return bool sum form error state 
		canBeSubmitted() {
				return (
						!this.state.passErr &&
						!this.state.usrnameErr &&
						!this.state.phoneErr &&
						!this.state.surnameErr &&
						!this.state.dateBirthErr &&
						!this.state.emailErr
				);
		}

		//TODO  
		isPasswordTheSame = () => {
      if(this.state.password.length >= 8 && this.state.password1.length >= 8){
				return this.state.password === this.state.password1;
      } 
      return false;
		}

		validatePassword = () => {
      var valid;
      if(this.state.password.length >= 8 && this.state.password1.length >= 8){
				valid = this.isPasswordTheSame();
      } else {
        valid = false;
      }

			this.setState({ passErr: !valid });
			return valid;
		}

		// should be validateFrom
		// @return bool sum fo all input validation

		validateInput = () => {
				return (
						this.validateName() &&
						this.validateSurname() &&
						this.validatePassword() &&
						this.validateEmail() &&
						this.validateITPhoneNumber()
				);
		}

		// validate name field.
		// set error class if is not properly formatted
		// @return bool response

		validateName = () => {
				var validName = (this.state.name != '');
				this.setState({ usrnameErr: !validName });
				return validName;
		}

		// validate surname field.
		// set error class if is not properly formatted
		// @return bool response

		validateSurname = () => {
				var validSurname = (this.state.name != '');
				this.setState({ surnameErr: !validSurname });
				return validSurname;
		}

		// validate email field from regexp.
		// set error class if is not properly formatted
		// @return bool response

		validateEmail = () => {
				var mail = this.state.email;
				var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
				var validEmail = regexp.test(this.state.email);
				this.setState({ emailErr: !validEmail })
				return validEmail;

		}

		// validate IT phone number field from regexp.
		// set error class if is not properly formatted
		// @return bool response

		validateITPhoneNumber = () => {
				var regexp = new RegExp(/^([0|\+[0-9]{1,5})?([7-9][0-9]{10})$/);
				var fullPhone = this.state.phoneCode + this.state.phone;
				var validPhone = regexp.test(fullPhone);
				this.setState({ phoneErr: !validPhone });
				return validPhone;
		}

		/* handles for each input values changes */

		handleChangeMonth = (m) => {
				let month = parseInt(m) + 1;
				this.setState({ month: month }, () => {
						this.regInfoValidator();
				});
		}

		handleChangeName = (e) => {
				this.setState({ name: e.target.value }, () => {
						this.regInfoValidator();
				});
		}

		handleChangeSurName = (e) => {
				this.setState({ surname: e.target.value }, () => {
						this.regInfoValidator();
				});
		}

		handleChangeEmail = (e) => {
				this.setState({ email: e.target.value }, () => {
						this.regInfoValidator();
				});
		}

		handleChangephone = (e) => {
				this.setState({ phone: e.target.value }, () => {
						this.regInfoValidator();
				});
		}

		handleChangePhoneCode = (e) => {
				//console.log("handleChangePhoneCode:", e.target.value);
				if (e.target.value === '00') {          
						this.setCountry('+');
						return;
				}
				this.setState({ phoneCode: e.target.value });
				this.setCountry(removeEmojis(e.target.value.replace(" ", "")));
		}

		handleChangePassword = (e) => {
				this.setState({ password: e.target.value }, () => {
						this.regInfoValidator();
				});
		}

		handleChangePassword1 = (e) => {
				this.setState({ password1: e.target.value }, () => {
						this.regInfoValidator();
				});
		}

		/*End handles for each input values changes */

		gotoConfirmMail = () => {

				this.setState({ redirect: true });

		}

		alertResponse(info) {
				switch (info.type) {
						case "closeButton":
								this.setState({ inScreenPopupShow: false })
								break;
						case "actionButton":
								if (info.option1 === "attention") {
										this.setState({ inScreenPopupShow: false })
										break;
								}
				}
		}

		// Default browser alert function replacement
		handleAlert = (incomingMsg) => {
				//console.log("Incoming message:", incomingMsg);
				this.setState({
						inScreenPopupShow: true,
						inScreenPopupMsg: incomingMsg,
				})
		}

		regInfoValidator = () => {
				const { name, surname, email, phoneCode, phone, dateBirth, password, password1, year, month, day } = this.state;
				// console.log("{ name, surname, email, phoneCode, phone, dateBirth, password }", { name, surname, email, phoneCode, phone, dateBirth, password });
				// console.log(
				//     '\nisStringValid(name) ', isStringValid(name),
				//     '\nisStringValid(surname) ', isStringValid(surname),
				//     '\nisEmailValid(email) ', isEmailValid(email),
				//     '\nthis.state.isCountryPrefixValid ', this.state.isCountryPrefixValid,
				//     '\nisPhoneValid(phone) ', isPhoneValid(phone),
				//     '\nisDobValid(year, month,day) ', isDobValid(year, month, day),
				//     '\nisPassValid(password)', isPassValid(password),
				// );
				this.setState({
						canBeSubmitted: (
								isStringValid(name) &&
								isStringValid(surname) &&
								isEmailValid(email) &&
								this.state.isCountryPrefixValid &&
								isPhoneValid(phone) &&
								isDobValid(year, month, day) &&
                this.validatePassword()
                )

				}, () => {
                  let passCheck = this.validatePassword();
                  this.setState({ passwordIsMatched: passCheck, passErr: !passCheck })
				})

		}

		onDayChangeHandler = (dd) => {
				//console.log("dd:", dd);
				let day = dd.padStart(2, '0');
				//console.log("day:", day);
				this.setState({ day });

		}

		onMonthChangeHandler = (mm) => {
				//console.log("mm:", mm);
				let month = mm.padStart(2, '0');
				//console.log("month:", month);
				this.setState({ month });


		}

		onYearChangeHandler = (yyyy) => {
				//console.log("year:", yyyy);
				this.setState({ year: yyyy });


		}

		refreshDays() {
				let { month, year } = this.state;
				var d = new Date();
				if (!month) {
						month = d.getMonth() + 1;
				}
				if (!year) {
						year = d.getFullYear();
				}
				this.setState({ dayList: getDaysInMonth(Number(month), Number(year)) }, () => {
						if (Number(this.state.day) > this.state.dayList.length) this.setState({ day: this.state.dayList.length.toString() });
						this.regInfoValidator();
				});
		}

		onLogout = () => {
				try {

						// fill storage w/ user data.
						userLogoutFetch(this).then((response) => {
								//console.log(response);
								localStorage.clear();
								cookies.remove('access_token');
								return this.props.history.push('/');
						});
				} catch (e) {
						//console.log(e);
				}
		}

		canNameSurnameBeModified =()=>{
				const {isModify, isFBLogin} = this.state;
				let modify = true;

				if (isModify && !isFBLogin) {
						modify = false;
				}

				return modify;
		}

		
		render() {
				// const isDisabled = !this.canBeSubmitted();
				//const isDisabled = this.isvalidObject.keys(errors).some(x => errors[x]);
				//console.log(this.state);

				return (
						<div>
							<div>
								<BrowserView>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row">
											<div className="col-2 d-flex align-items-center">
												<button className="sn_btnbox" onClick={()=>this.onLogout()}><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={logo} />
											</div>
										</div>
									</div>
									<div className="sn_topbar">
										<TopBar step={this.state.step} />
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_register">
										<div className="container-fluid">
											<div className="row">
												<div className="col-12 col-lg-10 mx-auto">
													<div className="sn_register__container">
														{/* <div className="row">
																<div className="col-12 d-flex justify-content-end">
																		<div className="sn_exit">
																				<a onClick={()=>this.onLogout()}>
																						<img src={clos} />
																				</a>
																		</div>
																</div>
														</div>
														<div className="row">
																<div className="col-12 my-3">
																		<div className="sn_title">
																				{!this.state.isModify ?tr.t("Insertdata"): tr.t('completeYourData')}
																		</div>
																</div>
														</div> */}
														<div className="row">
															<div className="col-3 d-none d-lg-block">
																<div className="big_arrow_wrap"><div className="big_arrow"></div></div>
															</div>
															<div className="col-12 col-lg-9">
															{
																this.canNameSurnameBeModified()&& 
																<div className="row align-start">
																	<div className="col-12 col-md-6">
																		<div className="sn_register__container__input mb-35 mb-sm-50">
																			<input type="text" 
																				spellCheck="false" 
																				name="Nome" 
																				placeholder={tr.t("Name")}
																				onBlur={() => (this.setState({ usrnameErr: !isStringValid(this.state.name) }))}
																				className={(this.state.usrnameErr) ? "err_red" : "err_no"}
																				maxLength="50" 
																				onChange={this.handleChangeName} 
																				value={this.state.name} 
																			/>
																		</div>
																	</div>
																	<div className="col-12 col-md-6">
																		<div className="sn_register__container__input mb-35 mb-sm-50">
																				<input type="text" 
																					spellCheck="false" 
																					name="surname" 
																					placeholder={tr.t("Surname")}
																					onBlur={() => this.setState({ surnameErr: !isStringValid(this.state.surname) })}
																					className={(this.state.surnameErr) ? "err_red" : "err_no"}
																					maxLength="50" 
																					onChange={this.handleChangeSurName} 
																					value={this.state.surname} 
																				/>
																		</div>
																	</div>
																</div>
																}
																<div className="row">
																	<div className="col-12 col-md-6">
																		<div className="sn_register__container__input mb-35 mb-sm-50">
																			<input disabled={this.state.isModify} 
																				type="email" 
																				name="email" 
																				spellCheck="false" 
																				placeholder={tr.t("Email")}
																				onBlur={() => this.setState({ emailErr: !isEmailValid(this.state.email) })}
																				className={(this.state.emailErr) ? "err_red" : "err_no"}
																				maxLength="50" 
																				onChange={this.handleChangeEmail} 
																				value={this.state.email} 
																			/>
																		</div>
																	</div>
																	<div className="col-12 col-md-6">
																		<div className="sn_register__container__input sn_telephone mb-35 mb-sm-50">
																			<input type="tel" 
																				name="phoneCode" 
																				placeholder={'🇮🇹 +39'} 
																				value={this.state.phoneCode}
																				onBlur={() => this.setState({ phoneErr: !this.state.isCountryPrefixValid })}
																				className={(this.state.phoneErr) ? "err_red" : "err_no"}
																				maxLength="9" 
																				onChange={this.handleChangePhoneCode} 
																			/>
																			<Cleave
																				className={(this.state.phoneErr) ? "err_red" : "err_no"}
																				onBlur={() => this.setState({ phoneErr: !isPhoneValid(this.state.phone) })}
																				options={{
																					blocks: [10],
																					numericOnly: true 
																				}}
																				onChange={this.handleChangephone}
																				placeholder={tr.t("Cellphone")}
																			/>
																		</div>
																	</div>
																</div>
																<div className="row">
																	<div className="col-12 col-md-6">
																		<p>{ tr.t("Birthday")}*</p>
																	</div>
																	<div className="col-12 col-md-6 mb-20">
																		<div className="sn_register__container__date">
																			<Dropdown
																				disabled ={!this.state.canModifyDateOfBirth}
																				arrowClassName='myArrowClassName'
																				menuClassName={'dopbtnid sn_datemenu'}
																				controlClassName={'dbuttonid sn_datebutton'}
																				options={this.state.dayList}
																				placeholder={tr.t("Day")}
																				onChange={((info) => {
																					this.setState({ day: info.value }, () => {
																						this.refreshDays();
																					});
																				})}
																				value={this.state.day}
																				ref={"dayList"}
																			/>
																			<Dropdown
																				disabled ={!this.state.canModifyDateOfBirth}
																				arrowClassName='myArrowClassName'
																				menuClassName={'mopbtnid sn_datemenu'}
																				controlClassName={'mbuttonid sn_datebutton'}
																				options={['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']}
																				placeholder={tr.t("Month")}
																				onChange={((info) => {
																					this.setState({ month: info.value }, () => {
																						this.refreshDays();
																					});
																				})}
																				value={this.state.month}
																			/>
																			<Dropdown
																				disabled ={!this.state.canModifyDateOfBirth}
																				arrowClassName='myArrowClassName'
																				menuClassName={'yopbtnid sn_datemenu'}
																				controlClassName={'ybuttonid sn_datebutton'}
																				options={getYears().reverse()}
																				placeholder={tr.t("Year")}
																				onChange={((info) => {
																					this.setState({ year: info.value.toString() }, () => {
																						this.refreshDays();
																					});
																				})}
																				value={this.state.year}
																			/> 
																		</div>
																	</div>
																</div>
																<div className="row">
																	<div className="col-12">
																		<p className="sn_minitext mb-40">*{tr.t("Necessary")}</p>
																	</div>
																</div>
                                
																{
																	!this.state.isModify &&
																	<div className="row">
																		<div className="col-12 col-md-6">
																			<div className="sn_register__container__input mb-35 mb-md-0">
																				<input 
																					disabled={this.state.isModify} 
																					type={(this.state.passFlagid) ? "password" : "text"} 
																					name="Password" 
																					placeholder={tr.t("Password")}
																					className={(this.state.passErr && (this.state.password.length !== 0 || this.state.password1.length !== 0)) ? "err_red sn_psw" : "err_no sn_psw"}
																					minLength="8" 
																					maxLength="50" 
																					onChange={this.handleChangePassword} 
																					value={this.state.password} 
																					spellCheck="false" 
																				/>
																				<div className="hideBtnPositionb">
																					{!this.state.isModify && <HideBtn changei={(i) => { this.setState({ passFlagid: i }) }} />}
																				</div>
																			</div>
																		</div>
																		<div className="col-12 col-md-6">
																			<div className="sn_register__container__input">
																				<input 
																					disabled={this.state.isModify} 
																					type={(this.state.passFlagid) ? "password" : "text"} 
																					name="Conferma Password" 
																					placeholder={tr.t("Confirmpass")}
																					className={(this.state.passErr && (this.state.password.length !== 0 || this.state.password1.length !== 0)) ? "err_red sn_psw" : "err_no sn_psw"}
																					minLength="8" 
																					maxLength="50" 
																					onChange={this.handleChangePassword1} 
																					value={this.state.password1} 
																					spellCheck="false" 
																				/>
																			</div>
																		</div>
																	</div>
																}
																{
																	!this.state.isModify &&
																	<div className="row mt-3 mb-5">
																		<div className="col-12">
																			<p className="sn_minitext">{ tr.t("Passleast") }</p>
																		</div>
																	</div>
																}
                                <div className="row mt-3 mb-5">
																		<div className="col-12">
                                      <p className="sn_minitext" style={{margin: 0}}>
                                         {tr.t('PrivacyCheck1')} <a href='https://mypass.ski/privacy/' target='_blank' style={{borderBottom: '1px solid white'}}>{tr.t('PrivacyPolicy')}</a> {tr.t('And')} <a href='https://mypass.ski/termini-uso/' target='_blank' style={{borderBottom: '1px solid white'}}>{tr.t('Terms')}</a> {tr.t('PrivacyCheck2')}.
                                      </p>
																		</div>
																	</div>
																<div className="row">
																	<div className="col-12 d-flex justify-content-center justify-content-sm-end">
																		<button className="sn_btn mr-sm-3 d-none d-lg-block" onClick={()=>this.onLogout()}>
																			{tr.t('back')}
																		</button>
																		<button 
																			className="sn_btn" 
																			onClick={this.gotoConfermail} 
																			disabled={!this.state.canBeSubmitted || !this.state.passwordIsMatched}>
																				{ tr.t(this.state.isModify ? "UpdateInfo" : "Next") }
																		</button>
																	</div>
																</div>
															</div>
														</div>
														<div className="row d-lg-none mt-5">
															<div className="col-12">
																<ProgressBullets step={this.state.step} />
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</BrowserView>
								<MobileView>
									<div className="container-fluid d-lg-none sn_mobile_top_row mt-5">
										<div className="row">
											<div className="col-2 d-flex align-items-center">
												<button className="sn_btnbox" onClick={()=>this.onLogout()}><img className="sn_mobile_top_row_arrow" src={ miniArrow }/></button>
											</div>
											<div className="col-8 d-flex align-items-center justify-content-center">
												<img className="sn_mobile_top_row_logo" src={logo} />
											</div>
										</div>
									</div>
									<div className="sn_topbar">
										<TopBar step={this.state.step} />
									</div>
									<div className="sn_overlay d-lg-none"></div>
									<div className="sn_register">
										<div className="container-fluid">
											<div className="row">
												<div className="col-12 col-lg-10 mx-auto">
													<div className="sn_register__container">
														{/* <div className="row">
																<div className="col-12 d-flex justify-content-end">
																		<div className="sn_exit">
																				<a onClick={()=>this.onLogout()}>
																						<img src={clos} />
																				</a>
																		</div>
																</div>
														</div>
														<div className="row">
																<div className="col-12 my-3">
																		<div className="sn_title">
																				{!this.state.isModify ?tr.t("Insertdata"): tr.t('completeYourData')}
																		</div>
																</div>
														</div> */}
														<div className="row">
															<div className="col-3 d-none d-lg-block">
																<div className="big_arrow_wrap"><div className="big_arrow"></div></div>
															</div>
															<div className="col-12 col-lg-9">
															{
																this.canNameSurnameBeModified()&& 
																<div className="row align-start">
																	<div className="col-12 col-md-6">
																		<div className="sn_register__container__input mb-35 mb-sm-50">
																			<input type="text" 
																				spellCheck="false" 
																				name="Nome" 
																				placeholder={tr.t("Name")}
																				onBlur={() => (this.setState({ usrnameErr: !isStringValid(this.state.name) }))}
																				className={(this.state.usrnameErr) ? "err_red" : "err_no"}
																				maxLength="50" 
																				onChange={this.handleChangeName} 
																				value={this.state.name} 
																			/>
																		</div>
																	</div>
																	<div className="col-12 col-md-6">
																		<div className="sn_register__container__input mb-35 mb-sm-50">
																				<input type="text" 
																					spellCheck="false" 
																					name="surname" 
																					placeholder={tr.t("Surname")}
																					onBlur={() => this.setState({ surnameErr: !isStringValid(this.state.surname) })}
																					className={(this.state.surnameErr) ? "err_red" : "err_no"}
																					maxLength="50" 
																					onChange={this.handleChangeSurName} 
																					value={this.state.surname} 
																				/>
																		</div>
																	</div>
																</div>
																}
																<div className="row">
																	<div className="col-12 col-md-6">
																		<div className="sn_register__container__input mb-35 mb-sm-50">
																			<input disabled={this.state.isModify} 
																				type="email" 
																				name="email" 
																				spellCheck="false" 
																				placeholder={tr.t("Email")}
																				onBlur={() => this.setState({ emailErr: !isEmailValid(this.state.email) })}
																				className={(this.state.emailErr) ? "err_red" : "err_no"}
																				maxLength="50" 
																				onChange={this.handleChangeEmail} 
																				value={this.state.email} 
																			/>
																		</div>
																	</div>
																	<div className="col-12 col-md-6">
																		<div className="sn_register__container__input sn_telephone mb-35 mb-sm-50">
																			<input type="tel" 
																				name="phoneCode" 
																				placeholder={'🇮🇹 +39'} 
																				value={this.state.phoneCode}
																				className={(!this.state.isCountryPrefixValid) ? "err_red" : "err_no"}
																				maxLength="5" 
																				onChange={this.handleChangePhoneCode} 
																			/>
																			<Cleave
																				className={(this.state.phoneErr) ? "err_red" : "err_no"}
																				onBlur={() => this.setState({ phoneErr: !isPhoneValid(this.state.phone) })}
																				options={{
																					blocks: [10],
																					numericOnly: true
																				}}
																				onChange={this.handleChangephone}
																				placeholder={tr.t("Cellphone")}
																			/>
																		</div>
																	</div>
																</div>
																<div className="row">
																	<div className="col-12 col-md-6">
																		<p>{ tr.t("Birthday")}*</p>
																	</div>
																	<div className="col-12 col-md-6 mb-20">
																		<div className="sn_register__container__date">
																			<Dropdown
																				disabled ={!this.state.canModifyDateOfBirth}
																				arrowClassName='myArrowClassName'
																				menuClassName={'dopbtnid sn_datemenu'}
																				controlClassName={'dbuttonid sn_datebutton'}
																				options={this.state.dayList}
																				placeholder={tr.t("Day")}
																				onChange={((info) => {
																					this.setState({ day: info.value }, () => {
																						this.refreshDays();
																					});
																				})}
																				value={this.state.day}
																				ref={"dayList"}
																			/>
																			<Dropdown
																				disabled ={!this.state.canModifyDateOfBirth}
																				arrowClassName='myArrowClassName'
																				menuClassName={'mopbtnid sn_datemenu'}
																				controlClassName={'mbuttonid sn_datebutton'}
																				options={['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']}
																				placeholder={tr.t("Month")}
																				onChange={((info) => {
																					this.setState({ month: info.value }, () => {
																						this.refreshDays();
																					});
																				})}
																				value={this.state.month}
																			/>
																			<Dropdown
																				disabled ={!this.state.canModifyDateOfBirth}
																				arrowClassName='myArrowClassName'
																				menuClassName={'yopbtnid sn_datemenu'}
																				controlClassName={'ybuttonid sn_datebutton'}
																				options={getYears().reverse()}
																				placeholder={tr.t("Year")}
																				onChange={((info) => {
																					this.setState({ year: info.value.toString() }, () => {
																						this.refreshDays();
																					});
																				})}
																				value={this.state.year}
																			/> 
																		</div>
																	</div>
																</div>
																<div className="row">
																	<div className="col-12">
																		<p className="sn_minitext mb-40">*{tr.t("Necessary")}</p>
																	</div>
																</div>
																{
																	!this.state.isModify &&
																	<div className="row">
																		<div className="col-12 col-md-6">
																			<div className="sn_register__container__input mb-35 mb-md-0">
																				<input 
																					disabled={this.state.isModify} 
																					type={(this.state.passFlagid) ? "password" : "text"} 
																					name="Password" 
																					placeholder={tr.t("Password")}
																					className={(this.state.passErr && (this.state.password.length !== 0 || this.state.password1.length !== 0)) ? "err_red sn_psw" : "err_no sn_psw"}
																					minLength="8" 
																					maxLength="50" 
																					onChange={this.handleChangePassword} 
																					value={this.state.password} 
																					spellCheck="false" 
																				/>
																				<div className="hideBtnPositionb">
																					{!this.state.isModify && <HideBtn changei={(i) => { this.setState({ passFlagid: i }) }} />}
																				</div>
																			</div>
																		</div>
																		<div className="col-12 col-md-6">
																			<div className="sn_register__container__input">
																				<input 
																					disabled={this.state.isModify} 
																					type={(this.state.passFlagid) ? "password" : "text"} 
																					name="Conferma Password" 
																					placeholder={tr.t("Confirmpass")}
																					className={(this.state.passErr && (this.state.password.length !== 0 || this.state.password1.length !== 0)) ? "err_red sn_psw" : "err_no sn_psw"}
																					minLength="8" 
																					maxLength="50" 
																					onChange={this.handleChangePassword1} 
																					value={this.state.password1} 
																					spellCheck="false" 
																				/>
																			</div>
																		</div>
																	</div>
																}
																{
																	!this.state.isModify &&
																	<div className="row mt-3 mb-5">
																		<div className="col-12">
																			<p className="sn_minitext">{ tr.t("Passleast") }</p>
																		</div>
																	</div>
																}
																<div className="row">
																	<div className="col-12 d-flex justify-content-center justify-content-sm-end">
																		<button className="sn_btn mr-sm-3 d-none d-lg-block" onClick={()=>this.onLogout()}>
																			{tr.t('back')}
																		</button>
																		<button 
																			className="sn_btn" 
																			onClick={this.gotoConfermail} 
																			disabled={!this.state.canBeSubmitted || !this.state.passwordIsMatched}>
																				{ tr.t(this.state.isModify ? "UpdateInfo" : "Next") }
																		</button>
																	</div>
																</div>
															</div>
														</div>
														<div className="row d-lg-none mt-5">
															<div className="col-12">
																<ProgressBullets step={this.state.step} />
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
										</MobileView>
								</div>
								{
										this.state.inScreenPopupShow ?
										<div className="containerModal">
												{
														this.state.inScreenPopupShow ?
														<AlertPnl
																textbar1={tr.t("Attention")}
																secondbar={true}
																textbar2={this.state.inScreenPopupMsg}
																singlebtn={true}
																textbtn1={tr.t("Ok")}
																sizebtn={"medium"}
																option1={"attention"}
																callback={this.alertResponse.bind(this)}
														/> : null
												}
										</div> : null
								}
						</div>

				);
		}
}

export default Inseriscidati;

function removeEmojis(string) {
		var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

		return string.replace(regex, '');
}
//validating the email
function isEmailValid(email) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
}

function isStringValid(string) {
		if (!string) return false; // no empty string
		if (/^[\s]+$/.test(string)) return false; // no only white spaces string
		// if ((/[!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?]/.test(string)) || /\d/.test(string)) return false;//no only empty space or number
		return true;
}

function isPhoneValid(phone) {
		// return (phone.length == 10);
    var regexp = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
    if(regexp.test(phone)) {
      console.log("number", phone, "is valid");
    } else {
      console.log("number", phone, "is not valid");
    }
    return regexp.test(phone);
		// return (phone.length > 2); //considering special phone numbers
}

function isDobValid(y, m, d) {
		//console.log(y, m, d);

		return !!y && !!m && !!d;
}

function isPassValid(pass) {
		return (pass.length > 7)
}


/**
 * @param {int} The month number, 0 based
 * @param {int} The year, not zero based, required to account for leap years
 * @return {Date[]} List with date objects for each day of the month
 */
function getDaysInMonth(month, year) {
		month -= 1;
		//console.log("get days 3", month, year);
		var date = new Date(year, month, 1);
		var days = [];
		while (date.getMonth() === month) {
				days.push(new Date(date).getUTCDate());
				date.setDate(date.getDate() + 1);
		}
		days.push(days.length)
		days.splice(0, 1);

		for (var i in days) {
				days[i] = days[i].toString().padStart(2, '0');
		}
		return days;
}


function getYears(startYear) {
		var currentYear = new Date().getFullYear(), years = [];
		startYear = startYear || 1920;

		while (startYear <= currentYear) {
				years.push(startYear++);
		}

		return years;
}


// WEBPACK FOOTER //
// ./src/screens/Inseriscidati/Inseriscidati.js